export default __webpack_public_path__ + "2dbe85201ea57c32979cd39cf76614b2.png";